import { useContext } from "react";
import { useUser } from "utils/hooks";
import EventListener from "utils/eventListener";
import { EventContext } from "components/EventProvider";

export default function useEvents(callback) {
  const { instance } = useContext(EventContext);
  return instance;
};
